import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import useAuth from 'hooks/useAuth';
import SignIn from 'pages/SignIn';
import UserManagement from 'pages/user-management/UserManagement';
import BannerManagement from 'pages/banner-management/BannerManagement';
import ProductManagement from 'pages/product-management/ProductManagement';
import AdminLayout from 'components/AdminLayout';
import { LoadingProvider } from 'contexts/LoadingContext';
import { ConfirmDialogProvider } from 'contexts/ConfirmDialogContext';
import GlobalLoading from 'components/GlobalLoading';
import { Message } from 'components/ShireMessage';
import ShireConfirmDialog from 'components/ShireConfirmDialog';
import { CustomerManagement } from 'pages/customer-management/CustomerManagement';
import { VoucherManagement } from 'pages/voucher-management/VoucherManagement';
import PointsManagement from 'pages/points-management/PointsManagement';
import ChangePasswordModal from 'components/ChangePasswordModal';
import ScanQRCodeModal from 'components/ScanQRCodeModal';

function RequireAuth({ children }: { children: React.ReactNode }) {
  const { user, isLoading } = useAuth();

  if (isLoading) {
    return <GlobalLoading />
  }

  if (!user) {
    return <Navigate to="/signin" replace />;
  }
  return <>{children}</>;
}

function App() {
  const [openChangePasswordModal, setOpenChangePasswordModal] = useState(false);
  const [openScanQRCodeModal, setOpenScanQRCodeModal] = useState(false);

  const handleOpenChangePasswordModal = () => {
    setOpenChangePasswordModal(true);
  }

  const handleOpenScanQRCodeModal = () => {
    setOpenScanQRCodeModal(true);
  }

  return (
    <AuthProvider>
      <LoadingProvider>
        <ConfirmDialogProvider>
          <Router>
            <GlobalLoading />
            <Message />
            <ShireConfirmDialog />
          <Routes>
            <Route path="/signin" element={<SignIn />} />
            <Route element={<RequireAuth>
              <AdminLayout
                onOpenChangePasswordModal={handleOpenChangePasswordModal}
                onOpenScanQRCodeModal={handleOpenScanQRCodeModal} />
            </RequireAuth>}>
              <Route path="/users" element={<UserManagement />} />
              <Route path="/banners" element={<BannerManagement />} />
              <Route path="/products" element={<ProductManagement />} />
              <Route path="/customers" element={<CustomerManagement />} />
              <Route path="/vouchers" element={<VoucherManagement />} />
              <Route path="/points-management" element={<PointsManagement />} />
              <Route path="*" element={<Navigate to="/users" replace />} />
            </Route>
          </Routes>
            <ChangePasswordModal open={openChangePasswordModal} onClose={() => setOpenChangePasswordModal(false)} />
            <ScanQRCodeModal open={openScanQRCodeModal} onClose={() => setOpenScanQRCodeModal(false)} />
          </Router>
        </ConfirmDialogProvider>
      </LoadingProvider>
    </AuthProvider>
  );
}

export default App;
